import { SxProps, Theme } from '@mui/material/styles';

export const titleMarkSX: SxProps<Theme> = {
	fontWeight: 'normal',
	fontSize: {
		xs: 'var(--font-size-caption)',
		sm: 'var(--font-size-default)',
	},
	color: '#2A2A2A',
	textAlign: 'center',
	listStyleType: 'none',
};
